import gql from 'graphql-tag';

export const PAGE_WINDOW_DATA = gql`
	query PageWindowData {
		device {
			ip
		}
	}
`;
